import { useAppSelector } from 'store/hooks'

export const useStepUserForm = () => {
  const currentEditForm = useAppSelector(
    state => state.orderForm.currentEditForm,
  )
  const rawEmail = useAppSelector(
    state => state.orderForm.forms[currentEditForm].email,
  )
  const rawPhone = useAppSelector(
    state => state.orderForm.forms[currentEditForm].phone,
  )

  const validateEmail = (value: string) => {
    const regex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$/
    return regex.test(value) || !value.length
  }

  const validatePhone = (value: string) => {
    const testPhone = value.replace(/[^\d+]/g, '')
    const regex = /^\+7\d{10}$/
    return regex.test(testPhone) || !value.length
  }

  return { rawEmail, rawPhone, validateEmail, validatePhone }
}
